const ru = {
  nav: {
    home: "Главная",
    about: "О Нас",
    destinations: "Направления",
    tours: "Туры и Пакеты",
    gallery: "Галерея",
    testimonials: "Отзывы",
    blog: "Блог",
    contact: "Контакты",
    experiences: "Впечатления",
    vip: "VIP Бизнес",
    vipFull: "VIP Бизнес-путешествия",
    worldcup: "Чемпионат мира 2030",
    jewishHeritage: "Кошерные туры",
    menu: "Меню",
    chatWhatsApp: "Чат в WhatsApp"
  },
  hero: {
    welcome: "Добро пожаловать в Марокко.",
    welcomeHome: "Добро пожаловать домой.",
    subtitle: "Частные роскошные туры, аутентичные впечатления,",
    subtitleLine2: "и полное персональное обслуживание по всему Марокко —",
    subtitleGold: "лично от генерального директора.",
    whatsappBtn: "Написать Илану (CEO) в WhatsApp сейчас",
    badgeFast: "Быстрый ответ",
    badgePersonal: "Индивидуальный подход",
    badge247: "Доступность 24/7",
    limitedAvail: "Ограниченное количество мест",
    personalizedOnly: "Только индивидуальные туры"
  },
  strip: {
    privateTours: "Частные Туры",
    localExperts: "Местные Эксперты",
    bestHotels: "Лучшие Отели",
    luxuryTransport: "Роскошный Транспорт",
    satisfaction: "100% Удовлетворенность"
  },
  cta: {
    whatsapp: "Написать Илану (CEO) в WhatsApp сейчас",
    whatsappFloating: "Чат в WhatsApp",
    whatsappInquiry: "Здравствуйте, меня интересует отдых премиум-класса в Марокко."
  },
  home: {
    vipBannerTitle: "VIP Путешествия по Марокко",
    vipBannerText: "Эксклюзивный доступ, личные водители и роскошное размещение для взыскательных путешественников.",
    vipBannerBtn: "Откройте для себя VIP-услуги",
    wcBadge: "🇲🇦 Чемпионат мира в Марокко 2030",
    wcTitle: "Марокко 2030",
    wcText: "Эксклюзивные туристические пакеты на Чемпионат мира, сочетающие футбол, марокканскую культуру, VIP-гостеприимство и роскошный отдых.",
    wcBtn: "Посмотреть Пакеты",
    galleryTitle: "Галерея",
    gallerySubtitle: "Взгляд в ваше будущее путешествие по Марокко",
    exploreDestination: "Исследовать направление",
    featuredToursTitle: "Популярные Туры и Пакеты",
    featuredToursSubtitle: "Тщательно отобранные впечатления для идеального марокканского приключения",
    viewAllTours: "Все Туры",
    culinaryTitle: "Наша еда — лучшая в мире",
    culinarySubtitle: "Ощутите кулинарное превосходство Марокко 🍲",
    culinaryBtn: "Кулинарные Впечатления",
    culinaryIntro: "В Morocco Loves You еда — это не просто прием пищи. Это путешествие в самое сердце марокканской культуры. Мы предлагаем аутентичные, тщательно отобранные кулинарные впечатления — от традиционных домашних блюд до высокой марокканской гастрономии, приготовленных с любовью и из самых свежих местных ингредиентов.",
    videoTitle: "РЕКОМЕНДАЦИИ",
    unityQuote: "Morocco Loves You приветствует все культуры, все верования и все народы.",
    unityAlt: "Баннер единства Morocco Loves You",
    testimonialsTitle: "Что Говорят Наши VIP-Гости",
    testimonialsSubtitle: "Реальные отзывы международных путешественников",
    readMoreReviews: "Читать Больше Отзывов",
    viewAllTransport: "Посмотреть весь транспорт",
    transportTitle: "Наш VIP-транспорт и водители",
    transportSubtitle: "Роскошь, комфорт и безопасность по всему Марокко 🌍",
    transportIntro: "В Morocco Loves You транспорт — это не просто перемещение из одного места в другое. Это часть впечатления. Мы предоставляем современные, чистые, комфортабельные автомобили с кондиционерами по всему Марокко — с профессиональными водителями, теплым гостеприимством и VIP-сервисом с самого первого момента."
  },
  tours: {
    pageTitle: "Туры и Пакеты",
    pageSubtitle: "Выберите из наших тщательно подготовленных туристических пакетов по Марокко",
    sectionTitle: "Наши Туристические Пакеты",
    sectionIntro: "От приключений в пустыне до пляжного отдыха — у нас есть идеальный пакет для каждого",
    howToBook: "Как Забронировать",
    step1Title: "Выберите Тур",
    step1Text: "Ознакомьтесь с нашими пакетами и выберите наиболее подходящий для вас",
    step2Title: "Нажмите 'Забронировать'",
    step2Text: "Нажмите кнопку 'Забронировать' в выбранном вами туре",
    step3Title: "Заполните Данные",
    step3Text: "Укажите даты поездки и личную информацию",
    step4Title: "Подтверждение",
    step4Text: "Получите подтверждение и детали маршрута по электронной почте",
    customTitle: "Нужен индивидуальный пакет?",
    customText: "Свяжитесь с нами, чтобы создать индивидуальный тур по Марокко",
    customBtn: "Свяжитесь с нами",
    days: "Дней",
    highlights: "Главное:",
    bookNow: "Забронировать",
    highlightsLabel: "ГЛАВНОЕ:",
    viewFullDetails: "Посмотреть все детали",
    premiumMoroccoPackages: "Премиальные пакеты по Марокко",
    premiumMoroccoPackagesDesc: "Эксклюзивные, тщательно подобранные впечатления для взыскательных гостей.",
    pkg1: {
      title: "Люксовый уикенд Европа/Марокко",
      duration: "3 ночи / 4 дня",
      price: "€790",
      hl1: "Прямые авиабилеты туда и обратно включены (Лондон/Европа)",
      hl2: "Люксовые отели 4-5 звезд",
      hl3: "Традиционный марокканский хаммам",
      hl4: "Кулинарные и художественные мастер-классы",
      hl5: "Марокканские живые выступления"
    },
    pkg2: {
      title: "Люксовый тур-открытие по Марокко",
      duration: "6 ночей / 7 дней",
      price: "€1490",
      hl1: "Пакет A",
      hl2: "Маршрут Атласа",
      hl3: "Марракеш - Эс-Сувейра - Мерзуга - Уарзазат - Марракеш",
      hl4: "Большой сюрприз ❤️",
      hl5: "Пакет B"
    },
    pkg3: {
      title: "Большое путешествие по Марокко",
      duration: "10 ночей / 11 дней",
      price: "€1990",
      hl1: "Полный премиальный наземный сервис",
      hl2: "Касабланка, Марракеш и Фес",
      hl3: "Агадир и сюрпризы пустыни Сахара",
      hl4: "Посещение Уарзазата и Шефшауэна",
      hl5: "Особая живая музыка и выступления"
    },
    pkg4: {
      title: "ЛЮКСОВОЕ ПУТЕШЕСТВИЕ ПО МАРОККО",
      duration: "16 ночей / 17 дней",
      price: "Все включено",
      hl1: "Касабланка • Рабат • Фес • Танжер • Шефшауэн",
      hl2: "Ифран • пустыня Сахара в Мерзуге",
      hl3: "Эс-Сувейра • Урика и Атласские горы • Марракеш",
      hl4: "2 ночи в люксовом лагере в пустыне с турами на верблюдах и джипах",
      hl5: "Волшебный рассвет и закат • Сон под звездами"
    }
  },
  destinations: {
    pageTitle: "Исследуйте Направления Марокко",
    pageSubtitle: "Откройте для себя невероятные места для посещения по всему Марокко",
    sectionTitle: "Все Направления",
    sectionIntro: "Марокко — страна с разнообразными ландшафтами и богатым культурным наследием. Исследуйте наши направления:",
    exploreNow: "Исследовать",
    ctaTitle: "Готовы спланировать поездку?",
    ctaText: "Просмотрите наши туры, чтобы найти идеальный отдых в Марокко",
    ctaBtn: "Посмотреть Туры"
  },
  experiences: {
    pageTitle: "Кулинарное Совершенство Марокко",
    pageSubtitle: "Откройте для себя нашу еду — лучшую в мире",
    bookViaWhatsApp: "Бронировать в WhatsApp"
  },
  vip: {
    pageTitle: "VIP и Бизнес-поездки",
    pageSubtitle: "Эксклюзивные услуги для генеральных директоров, инвесторов и взыскательных путешественников",
    introTitle: "Безупречное Качество в Марокко",
    introText: "MoroccoLovesYou предоставляет непревзойденный уровень обслуживания для деловых путешественников и VIP-гостей. Мы понимаем, что ваше время ценно, а стандарты бескомпромиссны.",
    ctaTitle: "Прямой Доступ к CEO",
    ctaText: "По срочным и узкоспециализированным запросам обращайтесь напрямую к нашему основателю и генеральному директору Илану Хатчуэлю.",
    ctaBtn: "Связаться с Иланом",
    luxuryTransport: "Роскошный Транспорт",
    luxuryTransportDesc: "VIP-трансферы из аэропорта и частные двуязычные водители доступны 24/7 на автомобилях премиум-класса (Mercedes S-Class, V-Class).",
    premiumAccom: "Премиум Размещение",
    premiumAccomDesc: "Эксклюзивное бронирование в 5-звездочных отелях, роскошных риадах или частных виллах.",
    businessConcierge: "Бизнес-консьерж",
    businessConciergeDesc: "Полное сопровождение встреч, бронирование частных ужинов и специализированные маршруты для корпоративных выездов.",
    securityPrivacy: "Безопасность и Приватность",
    securityPrivacyDesc: "Конфиденциальное обслуживание, безопасная среда и абсолютная секретность для высокопоставленных лиц.",
    support247: "Поддержка 24/7",
    support247Desc: "Прямая связь с генеральным директором и преданная команда, готовая помочь вам в любое время.",
    customItineraries: "Индивидуальные Маршруты",
    customItinerariesDesc: "Индивидуальные планы поездок, идеально сочетающие деловые обязательства с культурным опытом Марокко премиум-класса."
  },
  worldcup: {
    pageTitle: "Чемпионат Мира по Футболу 2030",
    pageSubtitle: "Эксклюзивные VIP-пакеты на крупнейшее футбольное событие",
    limitedBadge: "Ограниченное Количество",
    introTitle: "Идеальное Футбольное Путешествие",
    introText: "В 2030 году Марокко совместно примет Чемпионат мира по футболу. Мы с гордостью предлагаем эксклюзивные роскошные туристические пакеты 'все включено'.",
    packagesTitle: "Премиум-пакеты Чемпионата мира",
    silverTitle: "Серебряный Пакет",
    silverSub: "Базовый Опыт",
    goldTitle: "Золотой Пакет",
    goldSub: "Роскошный Опыт",
    mostPopular: "Самый Популярный",
    diamondTitle: "Бриллиантовый VIP",
    diamondSub: "Ультимативный Опыт",
    inquireWhatsApp: "Запрос в WhatsApp",
    ctaTitle: "Забронируйте Место до Повышения Цен",
    ctaText: "Из-за чрезвычайно высокого международного спроса мы настоятельно рекомендуем бронировать VIP-пакет заранее.",
    ctaBtn: "Свяжитесь с Нами Сегодня",
    silverF1: "Размещение в Риаде Премиум-класса / Отель 4 Звезды",
    silverF2: "Спланированная Логистика в День Матча",
    silverF3: "Экскурсии по Городам-организаторам",
    silverF4: "Выделенная Линия Поддержки 24/7",
    goldF1: "Отель 5 Звезд / Роскошная Вилла",
    goldF2: "Частный Трансфер (Аэропорт и Матчи)",
    goldF3: "VIP-отдых в Пустыне (2 дня)",
    goldF4: "Персональный Двуязычный Консьерж",
    diamondF1: "Президентские Люксы / Частные Дворцы",
    diamondF2: "Личный Водитель и Охрана 24/7",
    diamondF3: "Эксклюзивный Доступ на VIP-вечеринки",
    diamondF4: "Прямое Управление CEO и VVIP-Консьерж"
  },
  gallery: {
    pageTitle: "Наша Галерея",
    pageSubtitle: "Визуальные воспоминания о незабываемых поездках",
    picturesTitle: "Марокко в Фотографиях",
    picturesIntro: "Изучите нашу коллекцию захватывающих фотографий",
    videosTitle: "Марокко в Движении",
    videosIntro: "Почувствуйте Марокко через нашу видеоколлекцию"
  },
  testimonials: {
    pageTitle: "Отзывы Гостей",
    pageSubtitle: "Прочтите, что наши путешественники говорят о своем опыте",
    sectionTitle: "Наши Счастливые Путешественники",
    sectionIntro: "Тысячи довольных гостей испытали магию Марокко с нами",
    verifiedGuest: "Подтвержденный Гость",
    ratingsTitle: "Наши Оценки",
    avgRating: "Средняя Оценка",
    verifiedReviews: "Подтвержденные Отзывы",
    fromReal: "От реальных путешественников",
    custSatisfaction: "Удовлетворенность Клиентов",
    wouldRecommend: "Порекомендовали бы",
    shareTitle: "Поделитесь Своим Опытом",
    shareText: "У вас была замечательная поездка с нами? Мы хотели бы услышать о ней!",
    shareBtn: "Рассказать Историю"
  },
  blog: {
    pageTitle: "Блог о Путешествиях",
    pageSubtitle: "Истории, советы и путеводители для вашего марокканского приключения",
    sectionTitle: "Последние Статьи о Путешествиях",
    sectionIntro: "Читайте наши последние статьи о путешествиях по Марокко",
    readMore: "Читать Дальше →",
    by: "Автор:",
    newsletterTitle: "Подпишитесь на Нашу Рассылку",
    newsletterText: "Получайте последние советы для путешествий и эксклюзивные предложения",
    newsletterPlaceholder: "Введите ваш email",
    subscribe: "Подписаться"
  },
  contact: {
    pageTitle: "Контакты",
    pageSubtitle: "Свяжитесь с нашей командой, чтобы спланировать ваше VIP-приключение",
    getInTouch: "Связаться с Нами",
    getInTouchText: "Мы здесь, чтобы помочь и ответить на любые ваши вопросы.",
    address: "Адрес",
    phone: "Телефон",
    email: "Email",
    businessHours: "Часы Работы",
    businessHoursText: "Понедельник - Пятница: 9:00 - 18:00\nСуббота: 10:00 - 16:00\nВоскресенье: Закрыто",
    followUs: "Мы в Соцсетях",
    formTitle: "Отправьте нам Сообщение",
    successMessage: "✓ Спасибо! Мы скоро свяжемся с вами.",
    fullName: "Полное Имя",
    emailAddress: "Email Адрес",
    phoneNumber: "Номер Телефона",
    subject: "Тема",
    selectSubject: "Выберите тему",
    tourInquiry: "Запрос на Тур",
    bookingQuestion: "Вопрос по Бронированию",
    customPackage: "Индивидуальный Пакет",
    feedback: "Обратная Связь",
    other: "Другое",
    message: "Сообщение",
    sendMessage: "Отправить Сообщение",
    mapTitle: "Найдите нас на Карте",
    faqTitle: "Часто Задаваемые Вопросы",
    faq1Q: "Когда лучше всего посетить Марокко?",
    faq1A: "Весна (Апрель-Май) и Осень (Сентябрь-Октябрь) предлагают лучшую погоду.",
    faq2Q: "Нужна ли мне виза для посещения Марокко?",
    faq2A: "Визовые требования зависят от вашего гражданства.",
    faq3Q: "Какая валюта используется в Марокко?",
    faq3A: "Официальной валютой является марокканский дирхам (MAD).",
    faq4Q: "На каком языке говорят в Марокко?",
    faq4A: "Арабский и берберский являются официальными языками. Широко распространен французский.",
    faq5Q: "Безопасно ли Марокко для туристов?",
    faq5A: "Да, Марокко в целом безопасно. Наши гиды гарантируют вашу безопасность.",
    faq6Q: "Могу ли я настроить свой туристический пакет?",
    faq6A: "Безусловно! Мы предлагаем индивидуальные пакеты."
  },
  about: {
    pageTitle: "О MoroccoLovesYou",
    pageSubtitle: "Ваш надежный партнер в открытии магии Марокко",
    storyTitle: "Наша История",
    storyP1: "Компания MoroccoLovesYou была основана с простой миссией: помочь путешественникам ощутить подлинную красоту и культуру Марокко.",
    storyP2: "Наша основательница влюбилась в Марокко и захотела поделиться этой страстью со всем миром.",
    missionTitle: "🎯 Наша Миссия",
    missionText: "Предоставлять исключительные туристические услуги, демонстрирующие богатое культурное наследие Марокко.",
    visionTitle: "🌟 Наше Видение",
    visionText: "Быть ведущей туристической компанией Марокко, известной своей надежностью.",
    whyTitle: "Почему Выбирают Нас?",
    expertTitle: "Экспертные Знания",
    expertText: "Наша команда обладает обширными знаниями о Марокко.",
    localTitle: "Местные Связи",
    localText: "Мы работаем с настоящими местными гидами.",
    valueTitle: "Лучшая Ценность",
    valueText: "Конкурентоспособные цены без ущерба для качества.",
    safetyTitle: "Безопасность и Поддержка",
    safetyText: "Круглосуточная поддержка и комплексная туристическая страховка включены.",
    sustainTitle: "Устойчивый Туризм",
    sustainText: "Мы поддерживаем местные сообщества и практикуем ответственный туризм.",
    bookingTitle: "Простое Бронирование",
    bookingText: "Простой процесс онлайн-бронирования с гибкими вариантами оплаты.",
    teamTitle: "Наша Команда",
    teamSubtitle: "Познакомьтесь с увлеченными людьми из MoroccoLovesYou",
    happyTravelers: "Счастливых Путешественников",
    yearsExp: "Лет Опыта",
    destinationsCount: "Направлений",
    satisfactionRate: "Уровень Удовлетворенности"
  },
  footer: {
    description: "Откройте для себя магию Марокко вместе с нами. Испытайте незабываемые приключения.",
    quickLinks: "Быстрые Ссылки",
    more: "Больше",
    contactInfo: "Контактная Информация",
    copyright: "© 2024 MoroccoLovesYou. Все права защищены."
  },
  starBanner: {
    ceoMessage: "СООБЩЕНИЕ CEO",
    watchVideo: "Посмотреть видео",
    readMessage: "& прочитать сообщение",
    getToKnow: "Познакомьтесь",
    ilanPersonally: "с Иланом лично"
  },
  tourMini: {
    days: "10 ДНЕЙ",
    nights: "/ 9 НОЧЕЙ",
    title: "ПРЕМИУМ ТУР\nВ МАРОККО",
    years: "2026 - 2027",
    departures: "ЕЖЕМЕСЯЧНЫЕ ВЫЕЗДЫ",
    allIncluded: "ВСЕ ВКЛЮЧЕНО\nПОЛНЫЙ ПАНСИОН",
    recommendations: "Рекомендации",
    recCount: "500+ довольных путешественников"
  },
  cityDetail: {
    notFound: "Город не найден",
    backHome: "На главную",
    discoverSubtitle: "Откройте для себя красоту и культуру",
    planTrip: "Спланировать поездку в",
    galleryOf: "Галерея",
    bookExperience: "Забронировать Опыт",
    requestItinerary: "Запросить Полный Маршрут",
    readyToVisit: "Готовы Посетить?",
    readyToVisitText: "Позвольте нам спланировать ваше идеальное путешествие в это удивительное место",
    planMyTrip: "Спланировать Поездку",
    talkExpert: "Поговорить с Экспертом"
  },
  transportation: {
    pageTitle: "VIP Транспорт и Водители",
    pageSubtitle: "Роскошь, Комфорт и Безопасность по всему Марокко",
    introTitle: "Наш VIP Транспорт и Водители",
    introP1: "В Morocco Loves You транспорт — это не просто перемещение из одного места в другое.",
    introP2: "Это часть впечатления.",
    introP3: "Мы предоставляем современные, чистые, комфортабельные автомобили с кондиционерами по всему Марокко — с профессиональными водителями, теплым гостеприимством и VIP-сервисом с самого первого момента.",
    introP4: "Путешествуете ли вы парой, семьей, бизнес-делегацией или частной группой, мы позаботимся о том, чтобы ваша поездка была безопасной, спокойной и незабываемой.",
    servicesTitle: "Наши транспортные услуги включают",
    servicesList: [
      "Современные VIP-автобусы",
      "Роскошные микроавтобусы",
      "Частные автомобили",
      "Джипы 4x4 для приключений в пустыне",
      "VIP-лимузины",
      "Встреча и проводы в аэропорту",
      "Профессиональные многоязычные водители",
      "Комфортное кондиционирование",
      "Чистые и ухоженные автомобили",
      "Холодильники в выбранных автомобилях",
      "ТВ и развлекательные системы",
      "Музыка во время поездки",
      "Безопасное и плавное вождение",
      "Поддержка 24/7 по всему Марокко"
    ],
    driversTitle: "Познакомьтесь с нашими водителями",
    driversText1: "Наши водители — часть семьи Morocco Loves You.",
    driversText2: "Профессиональные, уважительные, опытные и всегда готовые помочь с улыбкой.",
    driversText3: "Многие из наших водителей владеют несколькими языками и глубоко знают Марокко — это помогает нашим гостям чувствовать себя комфортно, безопасно и вовлеченно на протяжении всей поездки.",
    safetyTitle: "Безопасность и комфорт прежде всего",
    safetyText1: "Ваш комфорт и безопасность — наши главные приоритеты.",
    safetyText2: "Все автомобили проходят регулярное техническое обслуживание, чистку и тщательную подготовку перед каждой поездкой.",
    safetyText3: "Мы работаем только с проверенными профессиональными водителями и высококачественными транспортными партнерами.",
    categories: {
      buses: "VIP Автобусы",
      minibuses: "Роскошные микроавтобусы",
      cars: "Частные автомобили и VIP трансферы",
      jeeps: "Джипы 4x4 и транспорт в пустыне",
      meetDrivers: "Познакомьтесь с нашими водителями",
      videos: "Видео транспортного опыта"
    },
    videoGalleryTitle: "Видео VIP-опыта",
    ctaTitle: "Готовы исследовать Марокко с комфортом?",
    ctaSubtitle: "Поговорите напрямую с Алланом – CEO и основателем",
    whatsapp: "WhatsApp: +972546338757",
    moroccoLine: "Прямая линия в Марокко: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "Роскошные кошерные туры в Марокко",
    pageSubtitle: "Подлинное еврейское наследие, 100% кошерная кухня, роскошное гостеприимство и уникальные впечатления в Марокко.",
    introTitle: "Роскошный опыт еврейского наследия",
    introHeading: "Откройте подлинное еврейское Марокко",
    introText: "Откройте глубокие корни еврейской истории в Марокко через элегантное, аутентичное и премиальное путешествие. Мы создаем безупречные поездки для еврейских общин по всему миру, уделяя внимание наследию, связи и абсолютному комфорту.",
    introQuote: "«Марокко — земля терпимости и сосуществования, где еврейское наследие сохраняется с любовью и уважением.»",
    experiencesTitle: "Наши кошерные впечатления включают",
    experiencesList:     [
          "100% кошерная еда и рестораны",
          "Доступен личный кошерный шеф-повар",
          "Традиционная марокканско-еврейская кухня",
          "Роскошные отели 4 и 5 звезд",
          "Частный VIP-транспорт",
          "Профессиональные многоязычные гиды",
          "Туры по еврейскому наследию и синагогам"
    ],
    expFood: "100% кошерная еда",
    expRestaurant: "Кошерный ресторан",
    expChef: "Доступен личный кошерный шеф-повар",
    expCuisine: "Традиционная марокканско-еврейская кухня",
    expHotels: "Роскошные отели 4 и 5 звезд",
    expDeluxeHotels: "Отели deluxe доступны по запросу",
    expTransport: "Частный VIP-транспорт",
    expDrivers: "Профессиональные водители",
    expAC: "Автомобили с кондиционером",
    expWifi: "WiFi, TV и холодильники в отдельных автомобилях",
    expGuides: "Профессиональные многоязычные гиды",
    expStaff: "Персонал говорит на иврите / английском / французском / испанском / русском / немецком",
    expHeritage: "Туры по еврейскому наследию",
    expSynagogues: "Древние синагоги",
    expCemeteries: "Еврейские кладбища",
    expMuseums: "Еврейские музеи",
    expSpiritual: "Духовные и культурные впечатления",
    expDesert: "Впечатления в пустыне Сахара",
    expHammam: "Марокканский хаммам",
    expAttractions: "Уникальные достопримечательности по всему Марокко",
    expAssistance: "Поддержка 24/7",
    packagesTitle: "Гибкие кошерные туристические пакеты",
    packagesIntro: "Мы адаптируем каждую поездку под потребности, традиции, стиль путешествия, даты и ожидания гостей.",
    package4_5: "4-5 Days",
    package7_8: "7-8 Days",
    package10_11: "10-11 Days",
    package13_14: "13-14 Days",
    package21: "21 день",
    packageTailor: "Индивидуальные частные туры",
    packagesQuote: "«Мы адаптируем каждую поездку под потребности, традиции, стиль путешествия, даты и ожидания гостей.»",
    safetyTitle: "Комфортное, профессиональное и безопасное путешествие",
    safetyQuote: "«Наши туры проходят с высоким вниманием к комфорту, организации, качеству сервиса и профессиональной координации по всему Марокко.»",
    b2bTitle: "B2B-партнерство в еврейских путешествиях",
    b2bText: "Мы сотрудничаем с еврейскими общинами, синагогами, раввинами и кошерными туроператорами по всему миру, чтобы создавать значимые путешествия по наследию.",
    b2bPartnersList: "Мы работаем с: еврейскими общинами, синагогами, раввинами, еврейскими организациями, кошерными туроператорами и турагентствами по всему миру.",
    partnerBtn: "Стать партнером",
    galleryTitle: "Галерея кошерных впечатлений",
    videosTitle: "Избранные видео",
    ctaTitle: "Готовы начать путешествие?",
    msgAllan: "Написать Allan в WhatsApp",
    callMorocco: "Позвонить в Марокко: +212 6 63 63 05 79",
    ceoContact: "Связаться напрямую с Allan Hatchuel в WhatsApp",
    exploreBtn: "Исследовать кошерные туры"
  },
  aria: {
    openMenu: "Открыть меню",
    closeMenu: "Закрыть меню",
    whatsappSocial: "WhatsApp",
    kosherTravel: "Кошерные путешествия по Марокко",
    logoAlt: "Логотип MoroccoLovesYou",
    kingAlt: "Король Марокко",
    kosherOptionsAlt: "Кошерные опции",
    jewishHeritageArchitecture: "Архитектура еврейского наследия",
    kosherMoroccanTable: "Кошерный марокканский стол",
    luxuryHospitality: "Роскошное гостеприимство",
    kosherExperience: "Кошерный опыт",
    jewishHeritageMorocco: "Еврейское наследие Марокко",
    kosherFoodMorocco: "Кошерная еда в Марокко",
    jewishHeritageExperience: "Опыт еврейского наследия"
  }
};

export default ru;
